import styled from 'styled-components';

import { Button, Typography } from '@/components';

import { ButtonColorKey, ButtonVariant } from '@/interfaces';

import { TextStyles } from '@/constants';

const BUTTON_HEIGHT = 45;
const ADD_ICON_SIZE = 20;

export const SubmitButton = styled(Button).attrs({
  type: 'submit',
  variant: ButtonVariant.Primary,
  color: ButtonColorKey.Yellow,
  isPMTButton: true,
})`
  display: block;
  width: 100%;
  height: ${BUTTON_HEIGHT}px;
  margin-top: ${({ theme }) => theme.spacing[8]};

  &:focus {
    outline: revert;
  }

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const AddIcon = styled.img`
  height: ${ADD_ICON_SIZE}px;
  width: ${ADD_ICON_SIZE}px;
  margin-right: ${({ theme }) => theme.spacing[8]};
`;

export const AddParcelsText = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
  as: 'span',
})`
  color: ${({ theme }) => theme.colors.highEmphasisWhite};
  line-height: ${({ theme }) => theme.lineHeight[22]}; // for accented languages
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RecaptchaContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing[8],
  marginBottom: theme.spacing[8],
}));
